class CreditDateType {
  constructor(code, chineseName, englishName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

export const CODE_NAME = 'CreditDateType'

// ["开航日期","开票日期","财务审核日期"];
export const SAILDATE = new CreditDateType(0, 'sailDate', '开航日期')
export const BILLDATE = new CreditDateType(1, 'billDate', '开票日期')
export const CHECKDATE = new CreditDateType(2, 'checkDate', '财务审核日期')

export const CREDITDATETYPES = [SAILDATE, BILLDATE, CHECKDATE]

